// apps/web/src/pages/vendas/fechamento/aprovar-rascunho-dialog.tsx — Fase 12, WR-D1-04.
// Confirmação de "Aprovar rascunho": única ação irreversível do fluxo fiscal que não passava por diálogo. Explica o efeito
// (libera o envio à Omie, rascunho imutável) e só dispara o POST depois do segundo clique.
import { Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { COPIA_APROVAR_RASCUNHO, TITULO_APROVAR_RASCUNHO } from '../../../lib/vendas/fechamento';

interface AprovarRascunhoDialogProps {
  readonly aberto: boolean;
  readonly onAbertoChange: (aberto: boolean) => void;
  /** True enquanto o POST de aprovação está em voo (botões travados, o diálogo não fecha). */
  readonly aprovando: boolean;
  readonly onConfirmar: () => void;
}

export function AprovarRascunhoDialog({ aberto, onAbertoChange, aprovando, onConfirmar }: AprovarRascunhoDialogProps) {
  return (
    <Dialog open={aberto} onOpenChange={(proximo) => (aprovando ? undefined : onAbertoChange(proximo))}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{TITULO_APROVAR_RASCUNHO}</DialogTitle>
          <DialogDescription>{COPIA_APROVAR_RASCUNHO}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onAbertoChange(false)} disabled={aprovando}>
            Voltar
          </Button>
          <Button type="button" onClick={onConfirmar} disabled={aprovando}>
            {aprovando && <Loader2 className="animate-spin" aria-hidden="true" />}
            Aprovar e liberar para a Omie
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
